import React from "react";
import { useEffect,useState } from 'react';
import { Container, Button, Col, Row, Nav, NavDropdown, SplitButton } from "react-bootstrap";
import { EyeFill, EyeSlash, Eyedropper, Pen, PencilSquare, Person, PersonAdd, Plus, Search, Star, StarFill, Trash } from "react-bootstrap-icons";
import { FaUserCircle, FaEdit } from "react-icons/fa";
import './style.css';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import { SlArrowRight,SlMenu , SlUser, SlUserFollow} from "react-icons/sl";
import { FaUserLarge } from "react-icons/fa6";
import { BsBoxArrowRight } from "react-icons/bs";
import Accordion from 'react-bootstrap/Accordion';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import Modal from 'react-bootstrap/Modal';
import Collapse from 'react-bootstrap/Collapse';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { Link, useNavigate } from "react-router-dom";
import baseUrl from "../../../../services/api";
import axios from "axios";
import Moment from 'moment';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { BiFilter } from "react-icons/bi";
import SideBar from "../Componet/Sidebar";
import { Rings } from "react-loader-spinner";
import { Tabs, Tab } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Helmet} from "react-helmet";
import { Close, Group, More, ViewAgenda } from "@mui/icons-material";
const MemeberHome = () =>{
  const [show, setShow] = useState(false);
  const session_username = sessionStorage.getItem("name");
  const session_email = sessionStorage.getItem("email");
  const session_role = sessionStorage.getItem("role");
  const user_id = sessionStorage.getItem("user_id");
  const com_id = sessionStorage.getItem("com_id");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [members, setMembers] = useState(null);
  const [forms, setForms] = useState(null);
  const [allForms, setAllForms] = useState(null);
  const session_token = sessionStorage.getItem("token");
  const [formdata , setFormData] = useState(null);
  const [sortedData, setSortedData] = useState(null);
  const [sortBy, setSortBy] = useState(null);
  const [companyid, setCompanyId] = useState();
  const [compname, setComName] = useState();
  const [formtype, setFormtype] = useState();
  useEffect(() => {

    var item_value = sessionStorage.getItem("login");
  
    if (item_value != "1" ) {
      navigate("/login");
    }
    if( session_role != "admin"){
      navigate("/login");
    }
    // axios.defaults.headers.common = {
    //   Authorization: `Bearer ${session_token}`,
    // };
    axios
    .get(`${baseUrl}/company/users`)
    .then((value) => {
      console.log("Memeber Data", value);
      setMembers(value.data);
    })
    .catch((reason) => {
      console.log("reason", reason.response.data);
      if (reason.response.data.includes("Token")) {
        navigate("/login");
      }
    });

    axios
    .get(`${baseUrl}/getAllSample`)
    .then((value) => {
      console.log("Form Data", value);
      setFormData(value?.data);
    })
    .catch((reason) => {
      console.log("reason", reason.response.data);
      if (reason.response.data.includes("Token")) {
        navigate("/login");
      }
    });


    console.log('coming session id', com_id);
    axios
  .get(`${baseUrl}/company/${com_id}`)
  .then((value) => {
    console.log("companyyyyyyy ", value.data);
    setComName(value.data[0]?.companyname);
    setFormtype(value.data[0]?.type);
  })
  .catch((reason) => {
    console.log("reason comppppppppppp", reason.response.data);
    if (reason.response.data.includes("Token")) {
      navigate("/login");
    }
  });


  // Cleanup function to clear the interval when the component unmounts
  
  
  }, []);
  const [activeKey, setActiveKey] = useState('tab1');

  const handleClearSearch = () => {
    setSearchTerm('');
    axios
    .get(`${baseUrl}/getAllSample`)
    .then((value) => {
      console.log("Form Data", value);
      setFormData(value?.data);
    })
    .catch((reason) => {
      console.log("reason", reason.response.data);
      if (reason.response.data.includes("Token")) {
        navigate("/login");
      }
    });
   
  };

  const handleTabSelect = (key) => {
    setActiveKey(key);
    if (key === 'tab1') {
      setSortShow(false);
    }
    if (key === 'tab2') {
      setSortShow(true);
    }
  };

  function survy(){
    if(formtype == 'coffees'){
      navigate('/survey1');
    }else{
      navigate('/survey2');
    }

    
  }
  const [userData, setUserData] = useState({
    firstname: '',
    lastname: '',
    email: '',
    // password: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => ({ ...prevData, [name]: value }));
  }; 
  const sortbyedit = async() =>{
  
    await axios
     .get(`${baseUrl}/form/updated_at`)
     .then((value) => {
       console.log("Form Data updated date", value.data);
       setFormData(value?.data);
      
     })
     .catch((reason) => {
       console.log("reason", reason.response.data);
       if (reason.response.data.includes("Token")) {
         navigate("/login");
       }
     });
   
 }
 const sortbysampleid = async () =>{
   
 await axios
   .get(`${baseUrl}/form/samplecoffeeid`)
   .then((value) => {
     console.log("Form Data updated date", value.data);
     setFormData(value?.data);
    
   })
   .catch((reason) => {
     console.log("reason", reason.response.data);
     if (reason.response.data.includes("Token")) {
       navigate("/login");
     }
   });
 
 }
  const sortbycreatedat = async () =>{
   
 await  axios
   .get(`${baseUrl}/form`)
   .then((value) => {
     console.log("Form Data updated date", value.data);
     setFormData(value?.data);
    
   })
   .catch((reason) => {
     console.log("reason", reason.response.data);
     if (reason.response.data.includes("Token")) {
       navigate("/login");
     }
   });
 
 }
  const handleInvite = async () => {

    axios.post(`${baseUrl}/user`, userData)
      .then(response => {
        // alert("User Added successfully", response.data.password);
        navigator.clipboard.writeText(response.data.user.password);
        toast.success('user added sucssfully: this password:  ' + response.data.user.password + 'copied please share to user', {
          position: 'top-center',
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        
      });
        setShow(false);
      
        console.log(response.data);
      })
      .catch(error => {
       toast.error("user not added ! the email may be pre exist");
        console.error('Error saving data:', error);
      });
  
  };

  const handleConfirm = (email) => {
    const result = window.confirm('Do you want to Delete this memeber?');
    if (result) {
      axios.delete(`${baseUrl}/user/${email}`)
      .then((response) => {  
        toast.success('User Deleted sucssfully');
        console.log('User removed successfully', response?.data);
        window.location.reload();
      })
      .catch((error) => {  
        toast.error("You can't delete admins !");
        console.error('Error removing user', error);
      
        
      });
    } else {
     
      console.log('User clicked No');
    }
  };
const [searchTerm, setSearchTerm] = useState('');
const [sortshow, setSortShow] = useState(false);
const handlesortopen  = ()=>{
setSortShow(true);
}  
const handleDelete = (id) => {
  if (window.confirm("Are you sure you want to delete this record?")) {
    axios
      .delete(`${baseUrl}/deleteSample/${id}`)
      .then(() => {
        // setPost((prevPost) => prevPost.filter((item) => item._id !== id));
      
        alert("Record deleted successfully!");
        window.location.reload();
      })
      .catch((error) => {
        console.error(error);
        alert("Failed to delete the record.");
      });
  }
};
const handlesortclose  = ()=>{
  setSortShow(false);
  }  
  const handleSearch = async () => {
    try {
      const response = await axios.get(`${baseUrl}/searchAllSamples/${searchTerm}`);
     setFormData(response?.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  if (!members || !formdata) {
    return (
  
      <div class="content">
      <div class='sidebar'>
        <SideBar/>
      </div>
      <section class = "stuff">
        <center style={{alignItems:'center'}}>
      <Rings
    height="280"
    width="280"
    color="#4fa94d"
    radius="6"
    wrapperStyle={{}}
    wrapperClass=""
    visible={true}
    ariaLabel="rings-loading"
  /></center>
        </section>
      </div>
    );
  }
    return(

    

      <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Admin Dashboard | Coffee</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="icon" href="https://www.iconarchive.com/download/i134299/iconarchive/fat-sugar-food/Drink-Coffee.1024.png" type="image/x-icon"></link>
      </Helmet>
      <Modal size="sm" show={show} onHide={handleClose} animation={true}>
      <Modal.Body style={{ flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', gap: 10, display: 'inline-flex'}}>
      <div style={{flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 8, display: 'flex'}}>
      <div style={{color: '#606060', fontSize: 18, fontFamily: 'Poppins', fontWeight: '400', wordWrap: 'break-word'}}>First Name</div>
      <div style={{width: 256, paddingTop: 3, paddingBottom: 3, paddingLeft: 8, background: 'white', borderBottom: '1px #C4C4C4 solid', justifyContent: 'flex-start', alignItems: 'center', gap: 10, display: 'inline-flex'}}>
        <input type="text" class='modal-input' name='firstname' value={userData.firstname}
        onChange={handleInputChange}  style={{color: '#9B9B9B', fontSize: 21.60, fontFamily: 'Poppins', fontWeight: '400', wordWrap: 'break-word'}} />
      </div>
    </div>
    <div style={{flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 8, display: 'flex'}}>
      <div style={{color: '#606060', fontSize: 18, fontFamily: 'Poppins', fontWeight: '400', wordWrap: 'break-word'}}>Last Name</div>
      <div style={{width: 256, paddingTop: 3, paddingBottom: 3, paddingLeft: 8, background: 'white', borderBottom: '1px #C4C4C4 solid', justifyContent: 'flex-start', alignItems: 'center', gap: 10, display: 'inline-flex'}}>
        <input type="text" value={userData.lastname}
        onChange={handleInputChange} name="lastname" class='modal-input'  style={{color: '#9B9B9B', fontSize: 21.60, fontFamily: 'Poppins', fontWeight: '400', wordWrap: 'break-word'}} />
      </div>
    </div>
    <div style={{flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 8, display: 'flex'}}>
      <div style={{color: '#606060', fontSize: 18, fontFamily: 'Poppins', fontWeight: '400', wordWrap: 'break-word'}}>Email</div>
      <div style={{width: 256, paddingTop: 3, paddingBottom: 3, paddingLeft: 8, background: 'white', borderBottom: '1px #C4C4C4 solid', justifyContent: 'flex-start', alignItems: 'center', gap: 10, display: 'inline-flex'}}>
        <input type="email" class='modal-input' value={userData.email}
        onChange={handleInputChange} style={{color: '#9B9B9B', fontSize: 21.60, fontFamily: 'Poppins', fontWeight: '400', wordWrap: 'break-word'}} name="email" placeholder="name@example.com" />
      </div>
    </div>
    <div style={{alignSelf: 'stretch', height: 50, paddingTop: 8, paddingBottom: 8, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', gap: 10, display: 'flex'}}>
      <div type='button' onClick={handleInvite} style={{width: 120, paddingTop: 5, paddingBottom: 5, paddingLeft: 14, paddingRight: 14, background: '#113946', boxShadow: '0px 0px 12px rgba(0, 0, 0, 0.25)', borderRadius: 16, justifyContent: 'center', alignItems: 'center', gap: 10, display: 'inline-flex'}}>
        <div style={{color: 'white', fontSize: 15.92, fontFamily: 'Poppins', fontWeight: '700', wordWrap: 'break-word'}}>Add</div>
      </div>
    </div>
      </Modal.Body>
    </Modal>
    <ToastContainer />
<div class="content">
<div class="sidebar">
<SideBar/>
</div>

<div class="stuff">

     
        <div class="row desktop" style={{ padding: "20px" }}>
         
          <div class="col-md-3 items">
            <div class="row add-button">
              <div class='col-md-6'>
              <Button  onClick={handleShow}
               style={{marginLeft: 5}}
              className="add-btn"><Plus size={23} className="plus" /> Add Member</Button>
              </div>
              <div class='col-md-6'>
              <Button  onClick={survy}
               style={{marginLeft: 5}}
              className="add-btn"><Plus size={23}  className="plus" /> New Form</Button>
            </div>
              
                
            </div>
         <strong>  All Memebers</strong> 
         <hr />
            <div class="row">
            {members.map((member) => (
              <>
            
              
              
                <div style={{width: 350, height: 75, background: 'white', borderRadius: 16, overflow: 'hidden', justifyContent: 'flex-start', alignItems: 'flex-start', display: 'inline-flex'}}>
                <div style={{flex: '1 1 0', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', display: 'inline-flex'}}>
                <div style={{color: 'black', fontSize: 21.10, fontFamily: 'Poppins', fontWeight: '400', wordWrap: 'break-word'}}>{member.firstname
                } {member.lastname}</div>
                <div style={{alignSelf: 'stretch', paddingLeft: 4, paddingRight: 4, justifyContent: 'space-between', alignItems: 'center', display: 'inline-flex'}}>
                <div style={{color: 'black', fontSize: 12, fontFamily: 'Poppins', fontWeight: '400', wordWrap: 'break-word'}}>{member.email}</div>
                <div className="col d-flex justify-content-end" style={{marginLeft: 5}}>
                  {user_id == member.id?(""
                  ):(
                    <Button  onClick={() => handleConfirm(member.id)} style={{  background: '#EF6243', borderRadius: 8,justifyContent: 'flex-start', alignItems: 'flex-start', marginLeft: 10, display: 'flex',  border: 'none'}}><Trash size={10}/></Button>
                  
                  )}
                 
                  </div>
                <div style={{paddingBottom: 1, marginLeft:5,paddingLeft: 10, paddingRight: 10, background: '#1B5A6F', borderRadius: 8, justifyContent: 'flex-start', alignItems: 'flex-start', gap: 10, display: 'flex'}}>
                 
                  <div style={{color: 'white', fontSize: 11, fontFamily: 'Poppins', fontWeight: '400', wordWrap: 'break-word'}}>{member.formsCount} Forms</div>
                </div>
                </div>
                </div>
                </div>
              
              <hr />
              </>

              ))}
            </div>
            
          </div>


          <div class="col-md-8 make-scrollable">
            <div class="row justify-content-between">
              <div class="col-md-4"><h5>{compname?compname:"Deleted Company"}</h5></div>
                <div class='col-md-5'>
        <InputGroup className="mb-3">
        <Form.Control
          placeholder="Search Froms"
          aria-label="Search"
          aria-describedby="basic-addon2"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {searchTerm && (
        <Button onClick={handleClearSearch} variant="light"><Close/></Button>)}
        <Button style={{background:'#1B5A6F'}} onClick={handleSearch} id="button-addon2">
         <Search/>
        </Button>
      </InputGroup></div>
              <div class="col-md-3">
  <Dropdown  content="text">
      <SplitButton className="boxshadow"
    
      size="sm"  
            variant="light"
            id="dropdown-menu-align-center"
            title="Sort By">
         <Dropdown.Item  onClick={sortbycreatedat}>Created Date</Dropdown.Item>
          <Dropdown.Item onClick={sortbyedit}>Last Edited</Dropdown.Item>
          <Dropdown.Item onClick={sortbysampleid}>Number</Dropdown.Item>
        
      </SplitButton>
    </Dropdown>



              </div>

            </div>

            <hr />
            {formdata.length==0? <center style={{marginTop: 100}}><h3>No Forms ! </h3></center>:
            <Row className="container" style={{paddingLeft:"20px",  paddingTop:"10px"}}>

            {formdata.map((form) => (
    

     
    <div className="column">
   
    <div style={{ height: 120,  gap: 5, }}>
  <div style={{width: 300, height: 120, paddingTop: 5, paddingBottom: 5, background: 'white', boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.25)', borderRadius: 16, overflow: 'hidden', justifyContent: 'space-between', alignItems: 'flex-start', display: 'inline-flex'}}>
    <div style={{alignSelf: 'stretch', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-start', display: 'inline-flex'}}>
      <div style={{padding: 8,marginLeft: 5, borderTopLeftRadius: 12, borderTopRightRadius: 12, borderTop: '1px #C4C4C4 solid',borderLeft: '1px #C4C4C4 solid', borderRight: '1px #C4C4C4 solid', borderBottom: '1px #C4C4C4 solid', justifyContent: 'center', alignItems: 'center', gap: 4, display: 'inline-flex'}}>
        <div style={{width: 18, height: 18, position: 'relative'}}>
          <div style={{width: 12, height: 12, left: 0, right: 2, top: -4, position: 'absolute', }}><FaUserCircle size={20}/></div>
        </div>
        <div style={{color: '#232323', fontSize: 12, fontFamily: 'Poppins', fontWeight: '100',  textOverflow: 'ellipsis', width:'60px', whiteSpace: 'nowrap',overflow : 'hidden' }}>{form.nameofsurveyer}</div>
      </div>
      <div style={{paddingLeft: 8, paddingRight: 8, paddingTop: 4, paddingBottom: 4, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 5, display: 'flex'}}>
        <div style={{color: 'black', fontSize: 12.50, fontFamily: 'Poppins', fontWeight: '400', wordWrap: 'break-word'}}>Created: {Moment(form.createdat).format('D MMM Y')
}</div>
        <div style={{color: 'black', fontSize: 12.50, fontFamily: 'Poppins', fontWeight: '400', wordWrap: 'break-word'}}>Last edited: {Moment(form.updated_at).format('D MMM Y')}</div>
      </div>
    </div>
    <div style={{height: 120, paddingTop: 12, paddingBottom: 16, paddingLeft: 8, paddingRight: 8, flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', display: 'inline-flex'}}>
      <div style={{color: 'black', fontSize: 14, fontFamily: 'JetBrains Mono', fontWeight: '200',  textOverflow: 'ellipsis', width:'70px', whiteSpace: 'nowrap',overflow : 'hidden' }}>{form.samplecoffeeid?form.samplecoffeeid:"Null"}</div>
      <div style={{paddingTop: 8, paddingBottom: 8, paddingLeft: 12, paddingRight: 8, background: 'white', boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.25)', borderRadius: 16, justifyContent: 'center', alignItems: 'center', gap: 10, display: 'inline-flex'}}>
        <div style={{color: '#232323', fontSize: 11, fontFamily: 'Poppins', fontWeight: '700', wordWrap: 'break-word'}}><Trash   onClick={() => handleDelete(form.id)} color="red" type="button" size={20} /><Link  to={`/formview/${form.cfid}`}><ViewAgenda type='button' style={{marginLeft:10}} size={20} /></Link></div>
        <div style={{width: 32, height: 32, justifyContent: 'center', alignItems: 'center', gap: 10, display: 'flex'}}>
          <div style={{width: 24, height: 24, position: 'relative'}}>
           <Link style={{textDecoration: 'none', color:'black'}}  to={formtype=='coffees'? '/survey1': '/survey2'}
                      state={{ data: form, anotherVariable: "1" }}> 
           <div type="button" style={{width: 24, height: 24, left: 0, top: 0, position: 'absolute',  }}><PencilSquare size={20} /></div>
         </Link> </div>
        </div>
      </div>
    </div>
  </div>
</div>  
     </div>

     
   
   ))}


            </Row>

}
          </div>


        </div>
        <div class="mobile make-scrollable">
          <div style={{display: 'flex'}}>

          
        <div   style={{flex:'1', width: '100%',border:'none', height: 'auto', margin: 23, paddingLeft: '10px',  background: '#113946', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)', borderRadius: 16, overflow: 'hidden', border: '3px solid', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', gap: 4, display: 'inline-flex'}}>
  {/* <div onClick={handleShow} style={{color: 'white', fontSize: 14.92, fontFamily: 'Poppins', fontWeight: '700', wordWrap: 'break-word'}}>Add new member</div> */}
<div className="d-flex" style={{display: 'flex'}}>
              <div style={{flex: '1'}}>
              <div  onClick={handleShow}
               style={{ color:'white'}}
               type="button"
             ><Group/></div>
              </div>
              <div style={{flex:'1', marginLeft:8}}>
              <div  onClick={survy}
              type="button"
               style={{marginLeft: 1, color:'white'}}
             ><PencilSquare/></div>
            </div></div>
</div>
{sortshow ?  <div class="col" style={{flex: 1,marginRight:30, marginTop: 15}}>
          <DropdownButton
         
          variant="transparent"
          align={{ sm: 'center' }}
          title={<BiFilter/>}
          flip='false'
          id="dropdown-menu-align-responsive-2"
        >
         <Dropdown.Item onClick={sortbycreatedat}>Created Date</Dropdown.Item>
          <Dropdown.Item onClick={sortbyedit}>Last Edited</Dropdown.Item>
          <Dropdown.Item onClick={sortbysampleid}>Number</Dropdown.Item>
        </DropdownButton>
          </div> : ""}</div>
          <div class=''>
        <InputGroup>
        <Form.Control
          placeholder="Search Froms"
          aria-label="Search"
          aria-describedby="basic-addon2"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {searchTerm && (
        <Button onClick={handleClearSearch} variant="light"><Close/></Button>)}
        <Button style={{background:'#1B5A6F'}} onClick={handleSearch} id="button-addon2">
         <Search/>
        </Button>
      </InputGroup></div>

<Tabs activeKey={activeKey} onSelect={handleTabSelect} className="custom-tabs">
      <Tab   eventKey="tab1" title="Members List">
      <div class="row" style={{paddingLeft:"20px", overflow: 'auto', height: 'fit-content', paddingTop:"10px"}}>
            {members.map((member) => (
              <>
             <div style={{width:'100%', height: 75, background: 'white', borderRadius: 16, overflow: 'hidden', justifyContent: 'flex-start', alignItems: 'flex-start', display: 'inline-flex'}}>
                <div style={{flex: '1 1 0', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', display: 'inline-flex'}}>
                <div style={{color: 'black', fontSize: 21.10, fontFamily: 'Poppins', fontWeight: '400', wordWrap: 'break-word'}}>{member.firstname
                } {member.lastname}</div>
                <div style={{alignSelf: 'stretch', paddingLeft: 4, paddingRight: 4, justifyContent: 'space-between', alignItems: 'center', display: 'inline-flex'}}>
                <div style={{color: 'black', fontSize: 12, fontFamily: 'Poppins', fontWeight: '400', wordWrap: 'break-word'}}>{member.email}</div>
                <div className="col d-flex justify-content-end" style={{marginLeft: 5}}>
                {user_id == member.id?(""
                  ):(
                  <Button  onClick={() => handleConfirm(member.id)} style={{  border: 'none',background: '#EF6243', borderRadius: 8,justifyContent: 'flex-start', alignItems: 'flex-start', marginLeft: 10, display: 'flex'}}><Trash size={10}/></Button>
                  )}
                  </div>
                <div style={{paddingBottom: 1, paddingLeft: 10, marginLeft:5 ,paddingRight: 10, background: '#1B5A6F', borderRadius: 8, justifyContent: 'flex-start', alignItems: 'flex-start', gap: 10, display: 'flex'}}>
                  <div style={{color: 'white', fontSize: 11, fontFamily: 'Poppins', fontWeight: '400', wordWrap: 'break-word'}}>{member.formsCount} Forms</div>
                </div>
                </div>
                </div>
                </div>
              
              <hr />
              </>

              ))}
            </div>
      </Tab>
      <Tab eventKey="tab2"  title="Forms List">
      {formdata.length==0? <center style={{margin: 100}}><h3>No Forms ! </h3></center>:
      <Row className="" style={{paddingLeft:"20px", marginBottom: 50,height: '100vh', overflow:'auto', paddingTop:"10px"}}>

{formdata.map((form) => (



<div className="column">

<div style={{ height: 120,  gap: 5, }}>
  <div style={{width: 300, height: 120, paddingTop: 5, paddingBottom: 5, background: 'white', boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.25)', borderRadius: 16, overflow: 'hidden', justifyContent: 'space-between', alignItems: 'flex-start', display: 'inline-flex'}}>
    <div style={{alignSelf: 'stretch', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-start', display: 'inline-flex'}}>
      <div style={{padding: 8,marginLeft: 5, borderTopLeftRadius: 12, borderTopRightRadius: 12, borderTop: '1px #C4C4C4 solid',borderLeft: '1px #C4C4C4 solid', borderRight: '1px #C4C4C4 solid', borderBottom: '1px #C4C4C4 solid', justifyContent: 'center', alignItems: 'center', gap: 4, display: 'inline-flex'}}>
        <div style={{width: 18, height: 18, position: 'relative'}}>
          <div style={{width: 12, height: 12, left: 0, right: 2, top: -4, position: 'absolute', }}><FaUserCircle size={20}/></div>
        </div>
        <div style={{color: '#232323', fontSize: 12, fontFamily: 'Poppins', fontWeight: '100',  textOverflow: 'ellipsis', width:'60px', whiteSpace: 'nowrap',overflow : 'hidden' }}>{form.nameofsurveyer}</div>
      </div>
      <div style={{paddingLeft: 8, paddingRight: 8, paddingTop: 4, paddingBottom: 4, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 5, display: 'flex'}}>
        <div style={{color: 'black', fontSize: 12.50, fontFamily: 'Poppins', fontWeight: '400', wordWrap: 'break-word'}}>Created: {Moment(form.createdat).format('D MMM Y')
}</div>
        <div style={{color: 'black', fontSize: 12.50, fontFamily: 'Poppins', fontWeight: '400', wordWrap: 'break-word'}}>Last edited: {Moment(form.updated_at).format('D MMM Y')}</div>
      </div>
    </div>
    <div style={{height: 120, paddingTop: 12, paddingBottom: 16, paddingLeft: 8, paddingRight: 8, flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', display: 'inline-flex'}}>
      <div style={{color: 'black', fontSize: 14, fontFamily: 'JetBrains Mono', fontWeight: '200',  textOverflow: 'ellipsis', width:'70px', whiteSpace: 'nowrap',overflow : 'hidden' }}>{form.samplecoffeeid?form.samplecoffeeid:"Null"}</div>
      <div style={{paddingTop: 8, paddingBottom: 8, paddingLeft: 12, paddingRight: 8, background: 'white', boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.25)', borderRadius: 16, justifyContent: 'center', alignItems: 'center', gap: 10, display: 'inline-flex'}}>
        <div style={{color: '#232323', fontSize: 11, fontFamily: 'Poppins', fontWeight: '700', wordWrap: 'break-word'}}><Trash   onClick={() => handleDelete(form.id)} color="red" type="button" size={20} /><Link  to={`/formview/${form.cfid}`}><ViewAgenda type='button' style={{marginLeft:10}} size={20} /></Link></div>
        <div style={{width: 32, height: 32, justifyContent: 'center', alignItems: 'center', gap: 10, display: 'flex'}}>
          <div style={{width: 24, height: 24, position: 'relative'}}>
           <Link style={{textDecoration: 'none', color:'black'}}  to={formtype=='coffees'? '/survey1': '/survey2'}
                      state={{ data: form, anotherVariable: "1" }}> 
           <div type="button" style={{width: 24, height: 24, left: 0, top: 0, position: 'absolute',  }}><PencilSquare size={20} /></div>
         </Link> </div>
        </div>
      </div>
    </div>
  </div>
</div>  
</div>



))}


</Row>}
      </Tab>
    </Tabs>
</div>

</div> 

        
        </div>
   </>
    );
}
export default MemeberHome;